import React, { useEffect, useRef, useState } from "react";
import { Image } from "primereact/image";
import { ArrowButton } from "../../molecules/ArrowButton";
import "./home.css";
import { SectionBorder } from "molecules/SectionBorder";

export const HomeSlider = (props) => {
  const data = props.data;
  console.log("datadata", data?.main_banner);
  return (
    <>
      <div
        className="card justify-content-center relative "
        style={{ border: "0px" }}
      >
        <div className="mainImgHeaderContainer">
          <img
            src={`${
              data?.main_banner
                ? "" + data?.main_banner
                : "media/home_banners.png"
            }`}
            // src={ "media/home_banners.png"}
            alt="Image"
            className="mainImgHeader"
            style={{ objectFit: "cover" }}
          />
        </div>
        <div className="banner-text color-white  mobileContainer ">
          <div className="container  pr-0  pl-0 ">
            <div className="grid mb-6   ml-0 ">
              <div
                className="lg:col-10  md:col-10 sm:col-12 pr-1 pl-0"
                style={{ width: "100%" }}
              >
                <h1
                  className="banner-title text-white mb-2"
                  dangerouslySetInnerHTML={{ __html: data?.main_header_text }}
                ></h1>

                <p
                  className="banner-detail-text text-white my-5"
                  style={{ fontSize: "18px" }}
                  dangerouslySetInnerHTML={{
                    __html:
                      data?.main_header_sub_text ||
                      "We are elevating investment standards, safeguarding and improving asset quality",
                  }}
                >
                  {/* You can add fallback plain text here, but it's usually unnecessary
      when using dangerouslySetInnerHTML for content rendering */}
                </p>
                {/* <div className="container  px-2 -mr-2 -ml-2"> */}
                <div className="headerHr   " />
                {/* </div> */}

                <div className="container  pl-0">
                  <ArrowButton
                    width="170"
                    buttonText={
                      data?.main_header_hyperlink_text || "About Quantom"
                    }
                    bgColor="#C82027"
                    textColor="#fff"
                    url={data?.main_header_hyperlink_link}
                    className="red_button"
                    color="#fff"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
